import axios from "axios";
// import defaultUser from '../utils/default-user';

export async function signIn(id, password) {
  try {
    const userInfo = await axios.post(
      "https://capi.mlab.kr/Cems/Login/Login/",
      { companyCode: '1000000098' },
      { id: id }, 
      { password: password }
    );
    //console.log('userInfo:',userInfo);

    return {
      isOk: true,
      data:
        userInfo.data[0] === undefined ? userInfo.data[0][0] : userInfo.data[0],
    };
  } catch {
    return {
      isOk: false,
      message: "Authentication failed",
    };
  }
}

export async function getUser() {
  try {
    // console.log("auth.js getUser::", sessionStorage.getItem("userId"));
    // console.log(sessionStorage.getItem("userId"));

    if (sessionStorage.getItem("userId") !== undefined) {
      return {
        isOk: true,
        data: sessionStorage.getItem("userId"),
      };
    } else {
      return {
        isOk: false,
        data: null,
      };
    }
  } catch {
    return {
      isOk: false,
    };
  }
}

export async function createAccount(email, password) {
  try {
    // Send request
    // console.log(email, password);

    return {
      isOk: true,
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to create account",
    };
  }
}

export async function changePassword(email, recoveryCode) {
  try {
    // Send request
    // console.log(email, recoveryCode);

    return {
      isOk: true,
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to change password",
    };
  }
}

export async function resetPassword(email) {
  try {
    // Send request
    // console.log(email);

    return {
      isOk: true,
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to reset password",
    };
  }
}
